import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Redirect, useParams } from 'react-router-dom';
import { useGeoLocation } from '../../../hooks/Front/home/useHome';
import Footer from '../../components/foter/footer';
import Navbar from '../../components/navbar/navbar';
import useModelo from '../../../hooks/Front/modelo/useModelo';
import SeccionesFicha from '../../components/fichaModelo/seccionesFicha';
import CentrosMantencion from '../../components/centrosMantencion/centrosMantencion';
import LoaderContainerMobile from '../../components/loader/LoaderContainerMobile';
import Recomendados from '../../components/fichaModelo/recomendados';
import iconAsesoria from '../../../img/floating/asesoria.svg';
import iconDescarga from '../../../img/ficha/descargar.svg'
import iconCotizar from '../../../img/floating/cotizar.svg';
import { Breadcrumb, Button } from 'antd';
import Slider from '../../components/fichaModelo/slider';
import Seo from '../../components/seo/seo';

const FichaModelo = () => {
    const { slug } = useParams();


    const [ficha, loading, error] = useModelo(slug);
    const { geoLocation } = useGeoLocation();

    if (loading === true) return <LoaderContainerMobile />
    if (loading === false && error === true) return <Redirect to="/404" />;

    return (
        <>
            <Navbar whatsappVisible={true} />
            {ficha && ficha.Vehiculo && ficha.Vehiculo.Nombre && ficha.Vehiculo.descripcionCorta && ficha.Vehiculo.Etiqueta &&
                <Seo title={`${ficha.Vehiculo.Nombre} -`} description={ficha.Vehiculo.Nombre + '. ' + ficha.Vehiculo.descripcionCorta} keywords={ficha.Vehiculo.Etiqueta} />
            }
            <CentrosMantencion seccion="MODELOS" />
            <Container fluid>
                {ficha && ficha.Slider && ficha.Slider.length > 0 &&
                    <Row>
                        <Col xs={12} className="px-0">
                            <Slider multimedia={ficha.Slider} vehiculo={ficha.Vehiculo} />
                        </Col>
                    </Row>
                }
                <Row className="bg-white border-breadcrumb">
                    <Col className="my-1 my-md-3 px-2">
                        <Breadcrumb separator=">" className="parrafo-hyundai f-responsive-10">
                            <Breadcrumb.Item>
                                <Link to="/">Home</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <Link to="/vehiculos">
                                    Vehículos
                                </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                {ficha && ficha.Vehiculo && ficha.Vehiculo.Nombre && ficha.Vehiculo.Nombre}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="px-0 mb-4 mt-0 my-md-4">
                        {ficha && Object.keys(ficha).length > 0 &&
                            <SeccionesFicha ficha={ficha} />
                        }
                    </Col>
                </Row>
                {ficha && ficha.Recomendados && ficha.Recomendados.length > 0 &&
                    <Row>
                        <Col xs={12} md={11} lg={10} xl={9} className="mx-auto mt-3 mb-general px-0 d-none">
                            <h5 className="bold-title-hyundai text-center f-responsive-14">Productos recomendados</h5>
                            <Recomendados recomendados={ficha.Recomendados} />
                        </Col>
                    </Row>
                }
            </Container>
            {ficha && ficha.Vehiculo && ficha.FichaTecnica &&
                <BottomBar slug={slug} descarga={ficha?.FichaTecnica[0]?.Multimedia} geoLocation={geoLocation} />
            }
            <Footer float={true} />
        </>
    );
};


const BottomBar = ({ slug, descarga, geoLocation }) => {
    return (
        <Container className="bg-hyundai-light fixed-bottom floating-shadow" fluid>
            <Row>
                {/* OCULAR ON */}
                {/* {geoLocation && geoLocation.region && 
                    geoLocation.countryCode === "CL" && geoLocation.region === "RM" &&  */}
                {/* <Col className="px-0 min-h-floating floating-border-right">
                    <Button type="text" className="w-100 h-100 ocular-parent-toggler text-center">
                        <img src={iconAsesoria} alt="asesoria en linea" className="img-fluid icon-floating mr-md-2 mr-lg-3" />
                        <h6 className="bold-title-hyundai d-none d-md-inline color-float text-center">Asesoría en línea</h6>
                        <p className="bold-title-hyundai mb-0 font-floating-btn color-float d-md-none color-btn-floating ">Asesoría en línea</p>
                    </Button>
                </Col> */}
                {/* } */}
                {descarga &&
                    <Col className="px-0 min-h-floating">
                        <a href={descarga} target="_blank" rel="noopener noreferrer">
                            <Button type="text" className="w-100 h-100 bold-title-hyundai">
                                <img src={iconDescarga} alt="ficha técnica" className="img-fluid mr-md-2 mr-lg-3 icon-floating" />
                                <h6 className="bold-title-hyundai d-none d-md-inline color-float">Descargar ficha técnica</h6>
                                <p className="bold-title-hyundai mb-0 font-floating-btn d-md-none color-float color-btn-floating">Ficha técnica</p>
                            </Button>
                        </a>
                    </Col>
                }
                <Col className="px-0 bg-cotizar-floating min-h-floating">
                    <Link to={`/cotizar/vehiculo/${slug}`}>
                        <Button type="text" className="w-100 h-100  bold-title-hyundai ">
                            <img src={iconCotizar} alt="cotizar" className="img-fluid  icon-floating mr-md-2 mr-lg-3" />
                            <h6 className="bold-title-hyundai d-none d-md-inline text-white">Cotizar</h6>
                            <p className="bold-title-hyundai mb-0 font-floating-btn  d-md-none text-white">Cotizar</p>
                        </Button>
                    </Link>
                </Col>
            </Row>
        </Container>
    )
};


export default FichaModelo;